import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { UserCheck, Gift } from "lucide-react";
import { useAffiliateTracking } from "@/hooks/useAffiliateTracking";

interface AffiliateInfo {
  code: string;
  affiliateName: string;
  affiliateEmail?: string;
}

export const AffiliateReferralBanner = () => {
  const { getStoredAffiliateCode, getAffiliateInfo } = useAffiliateTracking();
  const [affiliateInfo, setAffiliateInfo] = useState<AffiliateInfo | null>(null);

  useEffect(() => {
    const checkAffiliateCode = async () => {
      const storedCode = getStoredAffiliateCode();
      console.log('AffiliateReferralBanner - Verificando código salvo:', storedCode);
      
      if (storedCode) {
        console.log('AffiliateReferralBanner - Buscando info do afiliado para:', storedCode);
        const info = await getAffiliateInfo(storedCode);
        console.log('AffiliateReferralBanner - Info do afiliado encontrada:', info);
        
        if (info) {
          setAffiliateInfo(info);
        }
      } else {
        console.log('AffiliateReferralBanner - Nenhum código de afiliado encontrado');
      }
    };

    checkAffiliateCode();
  }, [getStoredAffiliateCode, getAffiliateInfo]);

  if (!affiliateInfo) {
    return null;
  }

  return (
    <Card className="border-primary/20 bg-gradient-to-r from-primary/5 to-accent/5 mb-6">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10">
            <Gift className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <UserCheck className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-foreground">
                Você foi indicado por <span className="text-primary font-semibold">{affiliateInfo.affiliateName}</span>
              </span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              Ao se cadastrar, você e seu indicador poderão receber benefícios especiais!
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};